export const TRACKINGEVENTS = {
  DOMAIN: {
    RECEIPTS: "Receipts",
    CHECKOUT: "Checkout",
  },
  SUBDOMAIN: {
    RECEIPT_LIST: "ReceiptList",
    RECEIPT_DETAILS: "ReceiptDetails",
    RECEIPT_SETTINGS: "ReceiptSettings",
    REFUND: "Refund",
  },
  PAGE: {
    RECEIPT_LIST: "ReceiptList",
    RECEIPT_DETAILS: "ReceiptDetails",
    RECEIPT_SETTINGS: "ReceiptSettings",
    REFUND: "Refund",
  },
  ACTION: {
    VIEWED: "Viewed",
    ITEM_CLICKED: "ItemClicked",
    SEARCH_CLICKED: "SearchClicked",
    EXPORT_CLICKED: "ExportClicked",
    EXPORT_RETRY_LINK_CLICKED: "ExportRetryLinkClicked",
    DATEFILTER_CLICKED: "DateFilterClicked",
    DATA_FETCHED: "DataFetched",
    PRINT_CLICKED: "PrintClicked",
    EMAIL_CLICKED: "EmailClicked",
    RESENT: "Resent",
    MAP_CLICKED: "MapClicked",
    REFUND_CLICKED: "RefundClicked",
    SAVE_CLICKED: "SaveClicked",
    PREVIEW_CLICKED: "PreviewClicked",
    TAPPED_REFUND: "TappedRefund",
    TAPPED_CONFIRMATION: "TappedConfirmation",
    REFUND_FLOW_CANCELLED: "RefundFlowCancelled",
    REFUND_REQUEST_SUCCESSFUL: "RefundRequestSuccessful",
    REFUND_REQUEST_FAILURE: "RefundRequestFailure",
    TAPPED_SHOW_ORIGINAL_RECEIPT: "TappedShowOriginalReceipt",
    TAPPED_SHOW_REFUND: "TappedShowRefund",
    SEARCH_TYPED: "SearchTyped",
    SEARCH_EXECUTED: "SearchExecuted",
    DATE_FILTER_UPDATED: "DateFilterUpdated",
    SESSION_ENDED: "SessionEnded",
    BE_SEARCH_ENABLED: "BESearchEnabled",
    LOAD_MORE_CLICKED: "LoadMoreClicked",
  },
}

type EventType = {
  domain: string
  subdomain: string
  page: string
  action: string
  payload?: Record<string, unknown>
}

// TODO: Event for download retry
export const getEventForId = (
  id: string,
  payload?: Record<string, unknown>,
): EventType | null =>
  ({
    "receipt-list-page-viewed": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.VIEWED,
      payload,
    },
    "receipt-list-item-clicked": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.ITEM_CLICKED,
      payload,
    },
    "receipt-list-datepicker": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.DATEFILTER_CLICKED,
      payload,
    },
    "search-receipt-list-input": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.SEARCH_CLICKED,
      payload,
    },
    "search-receipt-list-search-typed": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.SEARCH_TYPED,
      payload,
    },
    "search-receipt-list-search-executed": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.SEARCH_EXECUTED,
      payload,
    },
    "backend-search-enabled": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.BE_SEARCH_ENABLED,
      payload,
    },
    "receipt-list-print-button": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.PRINT_CLICKED,
      payload,
    },
    "export-receipt-list-button": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.EXPORT_CLICKED,
      payload,
    },
    "receipt-list-data-fetched": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.DATA_FETCHED,
      payload,
    },
    "receipt-details-page-viewed": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_DETAILS,
      page: TRACKINGEVENTS.PAGE.RECEIPT_DETAILS,
      action: TRACKINGEVENTS.ACTION.VIEWED,
      payload,
    },
    "receipt-details-print-button": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_DETAILS,
      page: TRACKINGEVENTS.PAGE.RECEIPT_DETAILS,
      action: TRACKINGEVENTS.ACTION.RESENT,
      payload: { ...payload, resendChannel: "print" },
    },
    "receipt-details-email-button": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_DETAILS,
      page: TRACKINGEVENTS.PAGE.RECEIPT_DETAILS,
      action: TRACKINGEVENTS.ACTION.RESENT,
      payload: { ...payload, resendChannel: "email" },
    },
    "receipt-details-refund-button": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_DETAILS,
      page: TRACKINGEVENTS.PAGE.RECEIPT_DETAILS,
      action: TRACKINGEVENTS.ACTION.REFUND_CLICKED,
      payload,
    },
    "receipt-details-refund-checkout": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_DETAILS,
      page: TRACKINGEVENTS.PAGE.RECEIPT_DETAILS,
      action: TRACKINGEVENTS.ACTION.TAPPED_REFUND,
      payload,
    },
    "receipt-show-refund-link": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_DETAILS,
      page: TRACKINGEVENTS.PAGE.RECEIPT_DETAILS,
      action: TRACKINGEVENTS.ACTION.TAPPED_SHOW_REFUND,
      payload,
    },
    "receipt-show-original-link": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_DETAILS,
      page: TRACKINGEVENTS.PAGE.RECEIPT_DETAILS,
      action: TRACKINGEVENTS.ACTION.TAPPED_SHOW_ORIGINAL_RECEIPT,
      payload,
    },
    "receipt-details-map-link": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_DETAILS,
      page: TRACKINGEVENTS.PAGE.RECEIPT_DETAILS,
      action: TRACKINGEVENTS.ACTION.MAP_CLICKED,
      payload,
    },
    "date-filter-updated": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.DATE_FILTER_UPDATED,
      payload,
    },
    "session-ended": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_DETAILS,
      page: TRACKINGEVENTS.PAGE.RECEIPT_DETAILS,
      action: TRACKINGEVENTS.ACTION.SESSION_ENDED,
      payload,
    },
    "receipt-list-load-more-clicked": {
      domain: TRACKINGEVENTS.DOMAIN.RECEIPTS,
      subdomain: TRACKINGEVENTS.SUBDOMAIN.RECEIPT_LIST,
      page: TRACKINGEVENTS.PAGE.RECEIPT_LIST,
      action: TRACKINGEVENTS.ACTION.LOAD_MORE_CLICKED,
      payload,
    },
  })[id] ?? null
